<script setup lang="ts">
import {defineAsyncComponent} from "vue";
import type {NewsCategoriesInterface, NewsInterface} from "#server/types/NewsInterface";

const NewsGridTemplate1 = defineAsyncComponent(() => import("~/components/news/NewsGridTemplate1.vue"));
const { $api } = useNuxtApp();

interface propInterface {
    id:number
    categories:string|number
    order:string
    limit:number
    showHeader:boolean
    showFooter:boolean
    headerText:string;
    btnText:string;
    btnHref:string;
}
const props=defineProps<{
    config: propInterface,
    class?:string,
}>()

interface getSectionProductInterface {
    category:NewsCategoriesInterface,
    list:NewsInterface[]
}

const { locale } = useI18n();
const request = computed(() => ({ limit: props.config.limit, order: props.config.order || 'latest' }));
const key = computed(() => `section-news:${locale.value}:${props.config.categories || 'latest'}:${JSON.stringify(request.value)}`);
const { data } = await useAsyncData(key, () => $api<getSectionProductInterface>('blog/by/'+(props.config.categories || 'latest'), {
        method: 'GET', params: request.value,
    }));

const header=computed(()=>props.config.headerText || data.value?.category?.name || '');
</script>

<template>
  <div :class="props?.class || ''" v-if="data?.list?.length">
    <NuxtLinkLocale :to="data?.category?.real_url || props.config.btnHref || ''">
      <h2 class="section_title mb-5" v-if="props.config.showHeader && header">
        {{ header }}
      </h2>
    </NuxtLinkLocale>
    <NewsGridTemplate1 :list="data.list" />
    <NuxtLinkLocale
      v-if="props.config.showFooter"
      :to="props.config.btnHref || data?.category?.real_url || ''"
    >
      <div class="d-flex justify-content-center">
        <div class="el-button el-button--primary el-button--default is-round">
          {{ props.config.btnText }}
        </div>
      </div>
    </NuxtLinkLocale>
  </div>
</template>
